import React, { useCallback } from "react";
import i18n from "i18next";
import ViewToolbar from "../view_toolbar/ViewToolbar";
import PluginToolbar from "../plugin_toolbar/PluginToolbar";
import { isCanvasElement, isSlide } from "../../../../common/utils";
import IdealStudio from "../../../../core/editor/main";
import PropTypes from "prop-types";
import {
  Tooltip,
  FormControl,
  OverlayTrigger,
  Popover,
  InputGroup,
  FormGroup,
  FormCheck,
  FormLabel,
  Button,
  Accordion,
} from "react-bootstrap";
function Toolbar(props) {
  const open = true;

  const toggleToolbar = useCallback(() => {}, []);

  let exercises = {};
  let toolbar = null;
  let title = "";
  let noBoxSelected =
    props.boxSelected === -1 &&
    isCanvasElement(props.navItemSelected, IdealStudio.Config.sections_have_content);
  let noPageSelected = false;
  if (!props.exercises[props.navItemSelected]) {
    noPageSelected = true;
  } else if (noBoxSelected) {
    exercises = props.exercises[props.navItemSelected];
    toolbar = (
      <ViewToolbar
        {...props}
        open={open}
        exercises={exercises}
        onScoreConfig={(id, button, value, page) => {
          props.onScoreConfig(id, button, value, props.navItemSelected);
        }}
        toggleToolbar={toggleToolbar}
        activeAccordionKey={props.activeAccordionKey}
      />
    );

    // title = (props.viewToolbars[props.navItemSelected].viewName || "");
    title =
      (isSlide(props.navItems[props.navItemSelected].type)
        ? props.navItems[props.navItemSelected].customSize === 0
          ? i18n.t("slide")
          : "PDF"
        : i18n.t("page")) || "";
  } else {
    exercises = props.exercises[props.navItemSelected].exercises[props.boxSelected];
    toolbar = (
      <PluginToolbar
        {...props}
        open={open}
        exercises={exercises}
        onScoreConfig={(id, button, value, page) => {
          props.onScoreConfig(id, button, value, props.navItemSelected);
        }}
        toggleToolbar={toggleToolbar}
        openConfigModal={props.openConfigModal}
        setUploadTemplateVisible={props.setUploadTemplateVisible}
        setAddSoundVisible={props.setAddSoundVisible}
        setSoundRecorderVisible={props.setSoundRecorderVisible}
        soundList={props.soundList}
        pageSoundList={props.pageSoundList}
        deleteSound={props.deleteSound}
        setAddSoundVisibleWithIndex={props.setAddSoundVisibleWithIndex}
        onServerModal={props.onServerModal}
      />
    );
    if (props.box && props.box.id) {
      let tb = props.pluginToolbars[props.box.id];
      let apiPlugin = tb ? IdealStudio.Plugins.get(tb.pluginId) : null;
      let config;
      if (apiPlugin) {
        config = apiPlugin.getConfig();
      } else {
        config = {};
      }
      title = config.displayName || "";
    } else {
      title = "";
    }
  }
  let isOpen = true;
  return (
    <div
      id="wrap"
      className="wrapper"
      style={{
        position: "relative",
        inset: "auto",
        width: "100%",
      }}
    >
      <div
        id="tools"
        style={{
          width: "100%",
          maxWidth: "100%",
        }}
        className={isOpen ? "toolbox toolsSpread" : "toolbox"}
      >
        <div id="insidetools" style={{ display: isOpen ? "block" : "none" }}>
          <div className="toolbarTabs">{toolbar}</div>
        </div>
      </div>
    </div>
  );
}

export default Toolbar;
Toolbar.propTypes = {
  /**
   * Selected box
   */
  boxSelected: PropTypes.any,
  /**
   * Current selected view (by ID)
   */
  navItemSelected: PropTypes.any,
  /**
   * Function for configuring the scoring settings of a page or exercise
   */
  onScoreConfig: PropTypes.func,
  /**
   * View toolbars
   */
  viewToolbars: PropTypes.object,
  /**
   * Callback for opening global configuration modal
   */
  openConfigModal: PropTypes.func,
  /**
   * Plugin toolbars
   */
  pluginToolbars: PropTypes.object,
  /**
   * Object containing the current box
   */
  box: PropTypes.object,
  /**
   * Top position
   */
  top: PropTypes.string,
  /**
   * Whether or not it should be toggled or visible
   */
  carouselShow: PropTypes.bool,
  /**
   * Object containing all exercises
   */
  exercises: PropTypes.object,
  /**
   * Object containing all views (by id)
   */
  navItems: PropTypes.object.isRequired,
};
